import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "inherit",
  "fill-rule": "evenodd",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20m5.359-14.737a7.564 7.564 0 0 0 0-10.705 7.584 7.584 0 0 0-10.718 0 7.564 7.564 0 0 0 0 10.705c.58.579.58 1.518 0 2.097s-1.52.579-2.099 0c-4.119-4.114-4.119-10.785 0-14.9 4.119-4.114 10.797-4.114 14.916 0 4.119 4.115 4.119 10.785 0 14.9-.58.579-1.52.579-2.1 0a1.48 1.48 0 0 1 0-2.097M20 20.304c.82 0 1.485.632 1.485 1.41v5.626c0 .779-.665 1.41-1.485 1.41s-1.484-.631-1.484-1.41v-5.626c0-.778.665-1.41 1.484-1.41m0-4.312c.82 0 1.485.663 1.485 1.482v.02a1.483 1.483 0 0 1-2.969 0v-.02c0-.819.665-1.482 1.484-1.482",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "IOT-token"}) } }